enum Actions {
  // action types
  ADD_BODY_CLASSNAME = "addBodyClassName",
  REMOVE_BODY_CLASSNAME = "removeBodyClassName",
  ADD_BODY_ATTRIBUTE = "addBodyAttribute",
  REMOVE_BODY_ATTRIBUTE = "removeBodyAttribute",
  ADD_CLASSNAME = "addClassName",
  VERIFY_AUTH = "verifyAuth",
  LOGIN = "Login",
  LOGIN_ATTEMPTS = "LoginAttempts",
  COMLOGIN = "LoginByCompany",
  LOGOUT = "Logout",
  REGISTER = "register",
  UPDATE_USER = "updateUser",
  FORGOT_PASSWORD = "forgotPassword",
  SET_BREADCRUMB_ACTION = "setBreadcrumbAction",
  ADD_PERMS = "addPerms",
  PURGE = "purge",
}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = "appendBreadcrumb",
  PURGE_AUTH = "purgeAuth",
  SET_AUTH = "setAuth",
  SET_USER = "setUser",
  SET_PASSWORD = "setPassword",
  SET_ERROR = "setError",
  SET_BREADCRUMB_MUTATION = "setBreadcrumbMutation",
  SET_LAYOUT_CONFIG = "setLayoutConfig",
  RESET_LAYOUT_CONFIG = "resetLayoutConfig",
  OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig",
  OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig",
  SET_PERMS = "setPerms",
}

enum Users {
  findPageUser = "findPageUser",
  saveUser = "saveUser",
  blockUser = "blockUser",
  deleteUser = "deleteUser",
  changePasswordSelf = "changePasswordSelf",
  changePassword = "changePassword",
  findUserByName = "findUserByName",
  findAllUser = "findAllUser",
  userDownload = "userDownload",
  findUserPermissions = "findUserPermissions",
  getUserInfo = "getUserInfo"
}
enum Menu {
  addMenu = "addMenu",
  viewMenu = "viewMenu",
  editMenu = "editMenu",
  deleteMenu = "deleteMenu",
  findMenuTree = "findMenuTree",
  findMenu = "findMenu",
  findNavTree = "findNavTree",
}

enum Roles {
  saveRole = "saveRole",
  deleteRole = "deleteRole",
  findPageRole = "findPageRole",
  findAllRole = "findAllRole",
  findRoleMenu = "findRoleMenu",
  saveRoleMenu = "saveRoleMenu",
  findRole = "findRole",
}

enum WebChatHistory{
  saveWebChatHistory = "saveWebChatHistory",
  deleteWebChatHistory = "deleteWebChatHistory",
  getWebChatHistoryById = "getWebChatHistoryById",
}

enum Questions{
  listQuestions = "listQuestions"
}

export {
  Actions,
  Mutations,
  Users,
  Menu,
  Roles,

  WebChatHistory,
  Questions
};
